import { DEFAULT_MODEL_KIND, MODEL_KINDS } from '@/features/projects/utils/modelSections';
import type { ModelKind } from '@/features/projects/utils/modelSections';
import type { Property } from '../api/detailsContracts';

/**
 * Core has no field for a model's kind, so it is kept in the model's own properties under this
 * reserved name. The property editor leaves it out, so only the Settings choice changes it.
 */
export const MODEL_KIND_PROPERTY = 'Model kind';

export const isModelKindProperty = (property: Property): boolean => property.key === MODEL_KIND_PROPERTY;

/** The kind a model's properties name; a model that names none is BIM. */
export function modelKindOf(items: readonly Property[] | undefined): ModelKind {
  const value = items?.find(isModelKindProperty)?.value.trim().toUpperCase();
  return MODEL_KINDS.find((kind) => kind === value) ?? DEFAULT_MODEL_KIND;
}

/** The properties with the model's kind set; BIM is the default, so it is stored as no property. */
export function withModelKind(items: readonly Property[], kind: ModelKind): readonly Property[] {
  const rest = items.filter((item) => !isModelKindProperty(item));
  return kind === DEFAULT_MODEL_KIND ? rest : [...rest, { key: MODEL_KIND_PROPERTY, value: kind }];
}
